var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-timer"},[(_vm.isInit)?_c('div',{class:_vm.type},[(_vm.times.d !== '00')?_c('b',{staticClass:"day"},[_vm._v(_vm._s(_vm.times.d))]):_vm._e(),_c('b',[_vm._v(_vm._s(_vm.times.h))]),_c('b',[_vm._v(_vm._s(_vm.times.m))]),_c('b',[_vm._v(_vm._s(_vm.times.s))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }